import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(rawNum) {
    if (rawNum == null) return '';
    else if (rawNum.indexOf('+47') == 0) {
      return rawNum;
    } else if (rawNum.includes('+')) {
      return rawNum;
    } else if (rawNum.length === 8) {
      return (
        '+47 ' +
        rawNum.substr(0, 3) +
        ' ' +
        rawNum.substr(3, 2) +
        ' ' +
        rawNum.substr(5, 3)
      );
    } else {
      return rawNum;
    }
  }
}
